import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { ShieldCheck, Award, Lightbulb, People, GlobeAmericas, HandThumbsUp } from "react-bootstrap-icons"; // Icons
import "./Kurumsal.css";

const PRINCIPLES = [
  {
    id: 1,
    title: "Güvenilirlik",
    desc: "Tüm paydaşlarımıza karşı şeffaf, dürüst ve güvenilir davranarak uzun vadeli, sağlam temellere dayanan ilişkiler kurarız.",
    icon: <ShieldCheck size={32} />
  },
  {
    id: 2,
    title: "Kalite",
    desc: "Ürün ve hizmetlerimizde uluslararası kalite standartlarını benimser, süreçlerimizi mükemmellik odağıyla sürekli iyileştiririz.",
    icon: <Award size={32} />
  },
  {
    id: 3,
    title: "Yenilikçilik",
    desc: "Teknolojiyi ve sektörel gelişmeleri yakından takip eder, değişime öncülük eden yaratıcı ve yenilikçi çözümler üretiriz.",
    icon: <Lightbulb size={32} />
  },
  {
    id: 4,
    title: "Müşteri Odaklılık",
    desc: "Müşterilerimizin ihtiyaçlarını proaktif bir yaklaşımla anlar, onlara değer katan ve beklentilerini aşan deneyimler sunarız.",
    icon: <HandThumbsUp size={32} />
  },
  {
    id: 5,
    title: "Sosyal Sorumluluk",
    desc: "Topluma ve çevreye karşı duyarlıyız. Sürdürülebilir bir gelecek için sosyal sorumluluk projelerini destekler ve rol alırız.",
    icon: <GlobeAmericas size={32} />
  },
  {
    id: 6,
    title: "Ekip Çalışması",
    desc: "Başarının bireysel değil, kolektif bir çaba olduğuna inanırız. Dayanışma, saygı ve ortak akıl ile hedeflerimize yürürüz.",
    icon: <People size={32} />
  }
];

const Kurumsal = () => {
  return (
    <div className="kurumsal-wrapper">
      {/* HERO SECTION */}
      <div className="kurumsal-hero text-center">
        <div className="hero-pattern"></div>
        <Container style={{ position: 'relative', zIndex: 1 }}>
          <h1 className="kurumsal-title display-4">Kurumsal İlkelerimiz</h1>
          <p className="kurumsal-desc mx-auto mt-3">
            Şirketimizin başarısının temelinde güven, kalite ve insana saygı yatar.
            Bu değerler, geleceği inşa ederken pusulamızdır.
          </p>
        </Container>
      </div>

      {/* CARDS SECTION */}
      <Container className="principles-section mb-5">
        <Row className="g-4 justify-content-center">
          {PRINCIPLES.map((item) => (
            <Col key={item.id} md={6} lg={4}>
              <Card className="principle-card h-100">
                <div className="icon-wrapper">
                  {item.icon}
                </div>
                <Card.Body className="p-0">
                  <h3 className="card-title">{item.title}</h3>
                  <p className="card-text">
                    {item.desc}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Kurumsal;
